import React, { forwardRef } from 'react';
import { Box } from '@saviynt/design-system';

import {
  TurnstileWidget,
  type TurnstileWidgetRef,
} from '../../../../shared/components';
import { type CaptchaField } from '../../../../shared/types';

import styles from './PreviewFields.module.css';

interface CaptchaProps {
  // eslint-disable-next-line react/no-unused-prop-types
  field: CaptchaField;
  siteKey?: string;
  onToken?: (token: string) => void;
  onExpired?: () => void;
  isPreview?: boolean;
}

const Captcha = forwardRef<TurnstileWidgetRef, CaptchaProps>(function Captcha(
  { siteKey, onToken, onExpired, isPreview },
  ref
) {
  return (
    <Box className={styles.captcha}>
      <TurnstileWidget
        ref={ref}
        siteKey={siteKey}
        onToken={onToken}
        onExpired={onExpired}
      />
      {isPreview && (
        <Box className={styles.captchaWidgetOverlay} aria-hidden='true' />
      )}
    </Box>
  );
});

export default Captcha;
